import React from "react";
import "./LoadingIndicator.css";

const LoadingIndicator = () => {
    return (
        <div className="spinner-container">
            <div className="spinner"></div>
        </div>
    );
};

export default LoadingIndicator;
